/*
    This is used to resolve un-expected null referece issue on the object.
*/
import { Injectable } from '@angular/core';
import * as _ from 'underscore';

@Injectable()
export class WcuObjectUtility  {
    constructor() {}

    /*  @objectProperties Object
    /   @defaultValue Any
    /   Extracts all keys from an object and returns them in an object. This method
    /   essentialy "resets" an object properties
    /   Optionally setting a default value to each of them
    */
    pluckKeys(objectProperties: any, defaultValue: any) {
        defaultValue = defaultValue || null;
        _.each(objectProperties, function(value, name) {
            objectProperties[name] = defaultValue;
        });

        return objectProperties;
    }

    /**
     * deepUpdate
     * This method takes an existing object and update the property values
     *     matched by the updatesObj property passed in.
     *     If a updatesObj property matches the currentObj property, the currentObj
     *         property gets updated.
     *     If a updatesObj property doesn't match a currentObj property,
     *         we then create the new property.
     * @currentObj Object current object to be updated
     * @updatesObj Object property values to update
     *------------------------------------------------------------------*/
    deepUpdate(currentObj: any, updatesObj: any) {
        _.each(updatesObj, function(node, property) {
            // Make sure the old structure contains the new properties
            currentObj = currentObj || updatesObj;
            if (_.isObject(node)) {
                this.deepUpdate(currentObj[property], updatesObj[property]);
            } else {
                currentObj[property] = node;
            }
        }.bind(this));
    }

    /*  This method takes a parent and loops through each to of the child as parent.prop
    /   to make sure the property is not null before accessing it.
    /
    /   @params parent object
    /   @params childStr string of children to loop through
    /   @params default object used if the validation fails, returns default instead of null
    /
    /   @return obj property value or null if object property is undefined
    */
    validateObj(parent: any, childStr?: string, defaultObj?: any) {
        var returnValue = parent;
        if (!parent || !childStr) {
            returnValue = null;
        } else {
            var children = childStr.split('.');
            var length = children.length;

            for (var i = 0; i < length; i++) {
                if (!_.isUndefined(returnValue[children[i]]) && !_.isNull(returnValue[children[i]])) {
                    returnValue = returnValue[children[i]];
                } else {
                    returnValue = null;
                    break;
                }
            }
        }

        if (!returnValue && !_.isUndefined(defaultObj)) {
            returnValue = defaultObj;
        }

        return returnValue;
    }

    readValue(parent: any, childStr?: string, defaultObj?: any) {
      var returnValue = parent;
      if (!parent || !childStr) {
          returnValue = null;
      } else {
            if (!_.isUndefined(returnValue[childStr]) && !_.isNull(returnValue[childStr])) {
                returnValue = returnValue[childStr];
            } else {
                returnValue = null;
            }
      }

      if (!returnValue && !_.isUndefined(defaultObj)) {
          returnValue = defaultObj;
      }

      return returnValue;
  }
    /*
        This method is used to return key if object and value is passed.
    */
    findKey(obj: any, value: any) {
        return _.invert(obj)[value];
    }

    /**
    * Returns a deep copy of the object
    */

    deepCopy(oldObj: any) {
        var newObj = oldObj;
        if (oldObj && typeof oldObj === "object") {
            newObj = Object.prototype.toString.call(oldObj) === "[object Array]" ? [] : {};
            for (var i in oldObj) {
                newObj[i] = this.deepCopy(oldObj[i]);
            }
        }
        return newObj;
    }

    /*Extend */
    addExtension(value, extension) {
        if (value) {
            return value + extension;
        }

        return value;
    }

}
